module.exports = __webpack_public_path__ + "h5/img/mfe_12.01c89c27.jpg";